import dynamic from "next/dynamic";
import ImagesLogosConfig from "./images-logos-config";
import ImagesLogosAdvancedConfig from "./images-logos-advanced-config";
const ImagesLogosComponent = dynamic(()=>import("./images-logos-component"));
export default {
    ImagesLogosComponent,
    ImagesLogosConfig,
    ImagesLogosAdvancedConfig
};
